export default "__VITE_ASSET__d4c600c9__"